<script>
export default {
    name: "BillerTerms"
}
</script>

<template>
    <article class="container">
        <h4 class="mt-3">Biller Service Terms and Conditions</h4>

        <h6>1. Introduction and Acceptance of Terms</h6>
        <p>Welcome to Magetsi’s Biller Service. By using this service, you agree to comply with and be bound by the following Terms and Conditions. If you do not agree to these terms, please do not use our services.</p>

        <h6>2. Definitions</h6>
        <p>
            • “Magetsi” refers to Qwiktech Solutions Pvt Ltd trading as Magetsi.<br>
            • “Platform” refers to the website, mobile application, or any other digital medium provided by Magetsi.<br>
            • “Customer” refers to any business, organization, or individual using Magetsi’s Biller Service.<br>
            • “Biller” refers to businesses, charities, or other organizations collecting payments through the Magetsi platform.<br>
            • “End User” refers to the individuals or entities making payments to the Biller via the Magetsi platform.
        </p>

        <h6>3. Service Overview</h6>
        <p>Magetsi’s Biller Service allows businesses, charities, and organizations to collect payments from their customers or benefactors through our platform. Magetsi processes these payments and transmits them to the Biller, less applicable fees and charges.</p>

        <h6>4. User Accounts</h6>
        <p>
            4.1. Account Creation: Billers are required to create an account and provide necessary documentation to access and use the service.<br>
            4.2. Account Security: Billers are responsible for maintaining the confidentiality of their account information and for all activities that occur under their account.
        </p>

        <h6>5. Payment Terms</h6>
        <p>
            5.1. Payment Methods: Magetsi accepts various payment methods from end users, including EcoCash, local bank transfers, and international cards.<br>
            5.2. Charges and Fees:
            <ul>
                <li>Payment Processing Fees: Magetsi will recover payment processing fees from the Biller for payments received from the Biller’s customers. These charges will depend on the payment method used (e.g., EcoCash, bank transfer, international card).</li>
                <li>Biller Platform Fees: Magetsi will charge Billers fees for the use of its platform. These fees will be communicated to the Biller prior to the use of the service.</li>
                <li>Payout Charges: Billers are responsible for any bank charges incurred during the transmission of collected funds.</li>
            </ul>
            5.3. Settlements: Funds collected will be transmitted to the Biller after deducting applicable fees and charges. Payouts will only be made to validated bank accounts in the same name as the Biller account.
        </p>

        <h6>6. Taxes</h6>
        <p>
            6.1. Value-Added Tax (VAT): A 15% VAT will be charged on the Biller Platform Fees.<br>
            6.2. Compliance: Billers are responsible for complying with all applicable tax regulations in their jurisdiction.
        </p>

        <h6>7. Refund Policy</h6>
        <p>
            7.1. Refunds: Magetsi will process refunds only at the request of the Biller and in accordance with the refund policy set by the Biller.<br>
            7.2. No Magetsi Obligation: Magetsi is not responsible for issuing refunds directly to end users unless directed by the Biller.
        </p>

        <h6>8. Use and Protection of Customer Information</h6>
        <p>
            8.1. Collection and Use of Information: Magetsi collects and processes information provided by Billers and end users for purposes related to providing and improving the service, including payment processing and identity verification.<br>
            8.2. Data Security: Magetsi implements appropriate security measures to protect personal information against unauthorized access, alteration, disclosure, or destruction.<br>
            8.3. Confidentiality: Information provided by users will be kept confidential and shared with third parties only as necessary for transaction processing or as required by law.<br>
            8.4. Compliance with Privacy Laws: Magetsi complies with applicable data protection and privacy laws in Zimbabwe to ensure responsible handling of customer information.<br>
            8.5. User Rights: Billers and end users have the right to request access to their personal data, correct inaccuracies, or request data deletion, subject to legal and operational limitations.<br>
            8.6. Third-Party Services: Magetsi may share personal information with trusted third-party service providers for payment processing or other necessary operations. These providers are required to protect the data and use it solely for the intended purposes.
        </p>

        <h6>9. KYC and Verification Procedures</h6>
        <p>Billers agree to provide accurate and current information for identity verification and due diligence checks. Magetsi reserves the right to perform necessary checks and validations to ensure compliance with anti-fraud and KYC regulations.</p>

        <h6>10. Risk Management and Fraud Protection</h6>
        <p>
            10.1. Right to Refuse Service: Magetsi reserves the right to refuse service, withhold funds, or take necessary action if fraudulent activities or high-risk transactions are suspected.<br>
            10.2. Investigation and Cooperation: Billers and end users are required to cooperate with any investigations into suspicious activities.<br>
            10.3. Liability for Fraudulent Activities: Users shall be liable for all costs, expenses, and losses incurred by Magetsi due to fraudulent activities, including legal fees and penalties imposed by payment processors.
        </p>

        <h6>11. Limitation of Liability</h6>
        <p>Magetsi is not liable for any direct, indirect, incidental, or consequential damages arising from the use of this service. Our liability is limited to the fees earned on the specific transaction in question.</p>

        <h6>12. Indemnification</h6>
        <p>Billers agree to indemnify, defend, and hold harmless Magetsi, its officers, directors, employees, agents, and affiliates from any claims, liabilities, damages, losses, and expenses arising out of or in any way connected with their use of the service or violation of these Terms and Conditions.</p>

        <h6>13. Amendments</h6>
        <p>Magetsi reserves the right to amend these Terms and Conditions at any time. Significant changes will be communicated to Billers, and continued use of the service will constitute acceptance of the revised terms.</p>

        <h6>14. Governing Law and Dispute Resolution</h6>
        <p>
            14.1. Governing Law: These Terms and Conditions are governed by the laws of Zimbabwe.<br>
            14.2. Dispute Resolution: Any disputes shall be resolved through arbitration in accordance with the Arbitration Act (Chapter 7:15).<br>
            14.3. Initial Resolution: Billers agree to contact Magetsi’s customer support to attempt to resolve disputes before initiating any external claim.
        </p>

        <h6>15. Contact Information</h6>
        <p>
            For any questions or concerns regarding these Terms and Conditions, please contact us at:<br>
            Magetsi<br>
            5th Floor Eastgate Center,<br>
            Cnr Sam Nujoma St/R.G Mugabe Rd,<br>
            Harare, Zimbabwe<br>
            Email: <a href="mailto:info@magetsi.co.zw">info@magetsi.co.zw</a><br>
            Phone: +263 78 583 2033
        </p>
        <p>By using Magetsi’s Biller Service, you acknowledge that you have read, understood, and agree to be bound by these Terms and Conditions.</p>
    </article>
</template>

<style scoped>

</style>
